<ion-grid class="ion-no-padding">
  <ion-row class="ion-justify-content-center ion-align-items-center">
    <ng-container
      *ngTemplateOutlet="Level; context: { ctx: Niveles | slice : 0 : 5 }"
    ></ng-container>
  </ion-row>

  <ng-container *ngIf="Niveles.length > 5">
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ng-container
        *ngTemplateOutlet="Level; context: { ctx: Niveles | slice : 5 : 10 }"
      ></ng-container>
    </ion-row>
  </ng-container>
</ion-grid>

<ng-template #Level let-niveles="ctx">
  <ng-container
    *ngFor="
      let nivel of niveles;
      let i = index;
      last as isLast;
      trackBy: trackByLevel
    "
  >
    <ion-col size="auto">
      <ion-chip
        mode="ios"
        class="step-chip"
        [ngClass]="{
          'step-chip-size-active': level === nivel.Nivel,
          'step-chip-editing':
            isEditing && !isEditingLocked && level !== nivel.Nivel
        }"
        (click)="isEditing && !isEditingLocked && onLevelClick(nivel.Nivel)"
      >
        <ion-label
          [ngClass]="
            level === nivel.Nivel || (isEditing && !isEditingLocked)
              ? 'step-label-active'
              : 'step-label-inactive'
          "
        >
          <ng-container *ngIf="level === nivel.Nivel">
            {{ 'Labels.level' | translate }}
          </ng-container>
          {{ nivel.Nivel }}
        </ion-label>
      </ion-chip>

      <ng-container *ngIf="shouldShowBadge(nivel)">
        <ion-badge
          color="getm-success-default"
          class="circle-badge animated fadeIn fast"
        >
          <ion-icon
            [name]="
              isEditing && (!isEditingLocked || level === nivel.Nivel)
                ? 'getm-edit-outline'
                : 'checkmark'
            "
          ></ion-icon>
        </ion-badge>
      </ng-container>
    </ion-col>

    <ion-col size="auto" *ngIf="!isLast">
      <hr class="connector-line" />
    </ion-col>
  </ng-container>
</ng-template>
